export default __webpack_public_path__ + "static/media/Vigilant Serpentweave.9fef66c5.jpg";